import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const DashboardLayout = ({ children, currentPage, onNavigate }) => {
    const { isDark } = useTheme();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const styles = {
        layout: {
            display: 'flex',
            minHeight: '100vh',
            background: isDark ? '#0a0a0a' : '#f8f9fa',
        },
        main: {
            flex: 1,
            marginLeft: isMobile ? 0 : '280px',
            marginTop: '64px',
            transition: 'all 0.3s ease',
            width: isMobile ? '100%' : 'calc(100% - 280px)',
            maxWidth: '100%',
            paddingLeft: 0,
        },
    };

    return (
        <div style={styles.layout}>
            <Sidebar
                currentPage={currentPage}
                onNavigate={onNavigate}
                isMobileOpen={isMobileMenuOpen}
                onMobileClose={() => setIsMobileMenuOpen(false)}
            />
            <Topbar onMenuClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
            <main style={styles.main}>
                {children}
            </main>
        </div>
    );
};

export default DashboardLayout;
